<template>
  <DetailLayout :inxbb-quick-view="inxbbQuickView">
    <template v-if="saleOrderProcessPermission" #detailLayoutTopRight>
      <div class="right-btn" @click="handleOpenSaleAnalys">
        <div class="right-btn__order-analysis">
          <i class="icon-edit2-ai-line t-iconfont"></i>
          <span>打单分析</span>
        </div>
      </div>
    </template>
    <template #detailLayoutBox>
      <div class="visit-path-detail">
        <div
          class="visit-path-detail__scroll"
          :class="{ 'visit-path-detail__scroll--is-inxbb-quick-view': inxbbQuickView }"
        >
          <template v-if="businessType === 100 && !inxbbQuickView">
            <div class="customer-name">{{ name }}</div>
          </template>
          <template v-else-if="businessType === 8000">
            <ClueBlock :name="name" :title-desc="titleDesc" />
          </template>
          <template v-if="isInit">
            <div v-loading="visitLoading" class="root-line">
              <div v-if="!inxbbQuickView" class="root-line__title">
                <i class="icon-footprint-line t-iconfont"></i>
                <span>拜访轨迹</span>
              </div>
              <VisitPath
                v-if="!visitLoading"
                v-model:active-stage-id="behavingId"
                :behaving-stage-list="behavingStageList"
                is-mobile
                @activeStageChange="handleActiveStageChange"
                @activeStageIdChange="handleActiveStageIdChange"
              ></VisitPath>
            </div>

            <TabLoading v-if="!subShow || !isInitEnd" />

            <TabCard
              v-if="subShow"
              ref="tabCardRef"
              :active-stage="activeStage"
              :ai-meeting-execute-strategy="aiMeetingExecuteStrategy"
              :ai-recommend-plan="aiRecommendPlan"
              :analyzing-status="analyzingStatus"
              :behaving-id="behavingId"
              :chat-list="chatList"
              :communicate-contents="communicateContents"
              :data-list="dataList"
              :employee-behavior-info="employeeBehaviorInfo"
              :inxbb-quick-view="inxbbQuickView"
              :is-audio="isAudio"
              :is-drawer="isDrawer"
              :is-liberal-rules="isLiberalRules"
              :is-session-archive="!!sessionArchiveParams.externalUserId"
              :meeting-duration="meetingDuration"
              :quality-analysis-info="qualityAnalysisInfo"
              :recommend-task-enable="recommendTaskEnable"
              :risk-result="riskResult"
              :suggestion="suggestion"
              :url="url"
              :yk-type="ykType"
              @handleRefresh="handleRefresh"
              @preview="handlePreview"
              @removeData="removeData"
              @startWithTime="handleStartWithTime"
            />
          </template>
        </div>
        <div
          v-if="isAudio"
          class="visit-path-detail__bottom"
          :class="{ 'visit-path-detail__bottom--is-inxbb-quick-view': inxbbQuickView }"
        >
          <AudioPlayer
            ref="audioPlayerRef"
            :audio-url="url"
            :chat-list="chatList"
            :inxbb-quick-view="inxbbQuickView"
            is-mobile
            show-download
          />
        </div>

        <div v-if="isShowPreview" class="preview-page">
          <video controls :src="previewFileUrl"></video>
          <i class="icon-arrow-left-s-line t-iconfont" @click="isShowPreview = false"></i>
        </div>
      </div>
    </template>
  </DetailLayout>

  <!-- 打单分析抽屉 -->
  <SaleAnalysDrawer
    v-model="showSaleAnalysDrawer"
    :business-type="businessType"
    :data-id="customerId"
  />
</template>

<script setup>
import DetailLayout from '@/pages/details/components/detail-layout.vue'
import { ref, onMounted, computed, provide } from 'vue'
import { useRoute } from 'vue-router'
import {
  getBehavingReviewDetail,
  getBehavingDetail,
  getClueBehavingReviewDetail,
  getSessionArchiveParams
} from '@/api/ai-board'
import ClueBlock from './components/clue-block.vue'
import TabCard from './components/tab-card.vue'
import VisitPath from '@/pages/ai-board/components/components/visit-path.vue'
import AudioPlayer from '@/components/audio-player.vue'
import utils from '@/utils'
import TabLoading from './components/tab-loading.vue'
import SaleAnalysDrawer from './components/sale-analys-drawer.vue'

// import { useAppStore } from '@/store/useAppStore'

defineOptions({
  name: 'VisitPathDetail'
})

const props = defineProps({
  isDrawer: {
    type: Boolean,
    default: false
  },
  detailQuery: {
    type: Object,
    default: () => ({})
  }
})

const route = useRoute()
const behavingId = ref('')
const activeStage = ref({})
const customerId = ref('')
const name = ref('')
const titleDesc = ref([])

const audioPlayerRef = ref(null)

const tabCardRef = ref(null)
const isInit = ref(false)
const behavingStageList = ref([])
const chatList = ref([])
const communicateContents = ref('')
const meetingDuration = ref('')
const isLiberalRules = ref(0) // 0 老规则 1 新规则
const url = ref('')
const dataList = ref([])
const riskResult = ref('')
const subShow = ref(false)
const saleOrderProcessPermission = ref(false) // 打单分析权限
const showSaleAnalysDrawer = ref(false) // 打单分析抽屉

const previewFileUrl = ref('')
const isShowPreview = ref(false)
// const isShowPreview = computed(() => useAppStore().isShowPreview)
// const setIsShowPreview = (val) => useAppStore().setIsShowPreview(val)
const isAudio = ref(false)

// 员工表现分析
const employeeBehaviorInfo = ref({})
const analyzingStatus = ref('')

const suggestion = ref('')
const evidence = ref([])
// 会话存档参数
const sessionArchiveParams = ref({})

// 质量分析信息
const qualityAnalysisInfo = ref({})
provide('evidence', evidence)
// 拜访轨迹加载状态
const visitLoading = ref(false)
// 行动建议数据
const aiMeetingExecuteStrategy = ref(null)
// ai推荐任务
const aiRecommendPlan = ref([])
const recommendTaskEnable = ref(false)
// 云客手机类型 ykMobile 云客电话, ykWechat 微信聊天
const ykType = ref('')
// 业务类型API枚举
const businessEnum = {
  100: {
    api: getBehavingReviewDetail,
    idKey: 'customerId',
    nameKey: 'customerName'
  },
  8000: {
    api: getClueBehavingReviewDetail,
    idKey: 'clueId',
    nameKey: 'clueName'
  }
}
const inxbbQuickView = ref(false)

const isInitEnd = computed(() => {
  return tabCardRef.value ? tabCardRef.value.isInitEnd : false
})

const businessType = computed(() => {
  const query = props.isDrawer ? props.detailQuery : route.query
  return +query?.businessType || 100
})

const isAudioFilter = (url) => {
  // audioUrl.value 链接是否是音频文件
  const audioExtensions = ['mp3', 'wav', 'ogg', 'flac', 'aac', 'm4a']
  if (!url) return false
  const ext = url.split('.').pop().toLowerCase()
  return audioExtensions.includes(ext)
}

const handlePreview = (url) => {
  previewFileUrl.value = url
  isShowPreview.value = true
  // setIsShowPreview(true)
}

const removeData = (index) => {
  aiRecommendPlan.value.splice(index, 1)
}

/**
 * @description: 切换音频播放时间
 * @param time 音频播放时间
 */
const handleStartWithTime = (time) => {
  audioPlayerRef.value.handleStartWithTime(time)
}

const handleActiveStageChange = (item) => {
  activeStage.value = item
}

/**
 * @description: 切换卡片
 * @param id
 */
const handleActiveStageIdChange = (id) => {
  chatList.value = []
  isLiberalRules.value = 0
  communicateContents.value = ''
  meetingDuration.value = ''
  suggestion.value = ''
  evidence.value = []
  analyzingStatus.value = ''
  url.value = ''
  dataList.value = []
  riskResult.value = ''
  subShow.value = false
  isAudio.value = false
  aiMeetingExecuteStrategy.value = null
  ykType.value = ''
  getBehavingDetail({
    behavingId: id
  })
    .then((res) => {
      // 下面所有的赋值内容 都要在 请求之前 初始化。因为直接在原页面上切换渲染数据
      communicateContents.value = res.result.communicateContents
      isLiberalRules.value = res.result.isLiberalRules
      chatList.value = res.result.aiAudioTopicAnalyseList || []
      meetingDuration.value = res.result.meetingDuration
      suggestion.value = res.result.suggestion
      evidence.value = res.result.evidence || []
      url.value = res.result.url
      analyzingStatus.value = res.result.analyzingForEmployeePerformance
      employeeBehaviorInfo.value = { taskId: id, ...res.result?.employeeBehavior } || {}
      recommendTaskEnable.value = res.result.recommendTaskEnable === 1
      aiRecommendPlan.value = res.result.taskList || []
      isAudio.value = isAudioFilter(res.result.url)
      dataList.value = res.result.data?.map((item) => {
        return {
          ...item,
          showSub: true
        }
      })
      riskResult.value = res.result.riskResult
      qualityAnalysisInfo.value = res.result
      ykType.value = res.result.ykType
      // 如果是企微公司则走此逻辑
      const paltFormType = utils.getPlatform(utils.xbbLocalStorageGet('corpid'))
      if (paltFormType === 'wx') {
        toGetSessionArchiveParams(id)
      }
      try {
        aiMeetingExecuteStrategy.value = {
          linkCommunicatePlanEnable: res.result.linkCommunicatePlanEnable,
          refiningCommunicatePlanEnable: res.result.refiningCommunicatePlanEnable,
          ...JSON.parse(res.result.aiMeetingExecuteStrategy || '{}')
        }
      } catch (error) {}
      saleOrderProcessPermission.value = res.result.saleOrderProcessPermission || false
    })
    .catch((err) => {
      console.log(err)
    })
    .finally(() => {
      subShow.value = true
      isInit.value = true
    })
}

// 获取企微参数
const toGetSessionArchiveParams = (behavingId) => {
  sessionArchiveParams.value = {}
  // 获取会话存档参数
  getSessionArchiveParams({
    behavingId
  }).then((res) => {
    const sessionParam = res.result.param || {}
    sessionArchiveParams.value = {
      externalUserId: sessionParam.externalUserId,
      from: sessionParam.from,
      sessionUserId: sessionParam.sessionUserId,
      sessionType: sessionParam.sessionType,
      msgType: 'all'
    }
  })
}

const handleOpenSaleAnalys = () => {
  console.log('打开打单分析抽屉')
  showSaleAnalysDrawer.value = true
}

// 刷新页面信息
const handleRefresh = () => {
  detailInit()
}

const detailInit = () => {
  visitLoading.value = true
  const api = businessEnum[businessType.value].api
  const idKey = businessEnum[businessType.value].idKey
  api({
    [idKey]: customerId.value,
    behavingId: behavingId.value
  })
    .then((res) => {
      titleDesc.value = res.result.title
      behavingStageList.value = res.result.behavingStageList.map((item) => {
        return {
          name: item.stageName,
          len: item.sessionCount,
          time: item.timeUse,
          items: item.communicateBehavingList
            ? item?.communicateBehavingList?.map((session) => {
                return {
                  id: session.behavingId,
                  name: session.customerName,
                  recordtime: session.communicateDuration,
                  type: session.communicateType,
                  sessionCreatorName: session.sessionCreatorName,
                  time: session.communicateTime,
                  kind: session.isRisk,
                  sourceType: session.sourceType
                }
              })
            : []
        }
      })
      handleActiveStageIdChange(behavingId.value)
    })
    .catch((err) => {
      console.log(err)
    })
    .finally(() => {
      visitLoading.value = false
      isInit.value = true
    })
}

const inxbbInit = () => {
  // 获取完整 URL 中的搜索参数部分（即 "?inxbb=1"）
  const searchParams = new URLSearchParams(window.location.search)
  // 通过参数名 "inxbb" 获取对应的值
  const inxbbValue = searchParams.get('inxbb') || ''
  const quickview = searchParams.get('quickview') || ''
  inxbbQuickView.value = (+inxbbValue === 1 && +quickview === 1) || props.isDrawer
}
onMounted(() => {
  const query = props.isDrawer ? props.detailQuery : route.query
  customerId.value = +query.customer
  behavingId.value = +query.id
  name.value = query.name
  detailInit()
  inxbbInit()
})
</script>

<style lang="scss" scoped>
.visit-path-detail {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .visit-path-detail__scroll {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    overflow-y: auto;
    padding: 0 8px 8px 8px;
    padding-bottom: 0px;
    .customer-name {
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      color: #323233;
      background: #ffffff;
      border-radius: 8px;
      padding: 12px;
      margin-bottom: 8px;
    }
    .root-line {
      position: relative;
      flex: 0 0 auto;
      width: 100%;
      padding: 12px 12px 0 12px;
      background: #ffffff;
      border-radius: 8px;
      .root-line__title {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        color: #646566;
        i {
          font-size: 16px;
        }
        span {
          margin-left: 8px;
          font-family: PingFang SC;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
  .visit-path-detail__bottom {
    flex: 0 0 auto;
    padding: 8px 8px 8px 8px;
  }
  .visit-path-detail__scroll--is-inxbb-quick-view {
    padding: 8px;
  }

  .visit-path-detail__bottom--is-inxbb-quick-view {
    box-sizing: border-box;
    border-top: 1px solid #f2f3f5;
  }

  .preview-page {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    overflow: hidden;
    background-color: #000;
    align-items: center;
    z-index: 9999;
    video {
      width: 100%;
      height: 50%;
    }
    .icon-arrow-left-s-line {
      position: absolute;
      left: 16px;
      top: 50px;
      font-size: 32px;
      color: #f2f3f4;
    }
  }
}
.right-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .right-btn__order-analysis {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 98px;
    height: 34px;
    border-radius: 12px;
    border: 1px solid rgba(124, 58, 237, 0.15);
    background: linear-gradient(289deg, #eef2ff 1%, #f5f3ff 100%);

    i {
      font-size: 14px;
      line-height: 14px;
      margin-right: 8px;
      background: linear-gradient(289deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }

    span {
      font-family: PingFang SC;
      font-size: 13px;
      line-height: 18px;
      background: linear-gradient(289deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
  }
}
</style>
